import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import P11Layout from "./P11Layout";
import P11StampCard from "./P11StampCard";
import { P11, fmtDate } from "./p11shared";
import { useP11Lang } from "./p11lang";

// THE RECORD — digitale stempelkaart.
export default function P11Record() {
  const nav = useNavigate();
  const { lang, tt } = useP11Lang();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/project11/me/record").then(({ data }) => setData(data)).catch(() => nav("/project11/login"));
  }, [nav]);

  if (!data) return <div className="p11-root min-h-screen flex items-center justify-center"><span className="p11-label">…</span></div>;

  return (
    <P11Layout>
      <div data-testid="p11-record">
        <div className="p11-label">{tt("session_tracker")}</div>
        <h1 className="p11-h1 text-4xl mt-4">{tt("record_title")}</h1>
        <div className="flex items-end gap-4 mt-8 mb-8">
          <span className="p11-mono text-5xl" style={{ color: P11.yellow }} data-testid="p11-record-count">{String(data.verified).padStart(2, "0")} / 08</span>
          <span className="p11-label mb-2">{tt("verified_sessions")}</span>
        </div>
        <P11StampCard stamps={data.stamps} />
        {data.completion_status && (
          <div className="mt-10 border p-6 text-center" style={{ borderColor: data.completion_status === "COMPLETED" ? P11.yellow : P11.border }} data-testid="p11-record-final">
            <div className="p11-h2 text-2xl" style={{ color: data.completion_status === "COMPLETED" ? P11.yellow : P11.text }}>
              {data.completion_status === "COMPLETED" ? tt("completed_title") : tt("incomplete_title")}
            </div>
            <p className="text-sm mt-3" style={{ color: P11.gray2 }}>{data.completion_status === "COMPLETED" ? tt("completed_body") : tt("incomplete_body")}</p>
          </div>
        )}
        <div className="mt-10 divide-y" style={{ borderColor: P11.border }}>
          {data.stamps.filter((s) => s.state !== "LOCKED").map((s) => (
            <div key={s.session_id} className="py-3 flex items-center justify-between" data-testid={`p11-record-row-${s.number}`}>
              <span className="p11-label">{tt("session")} {String(s.number).padStart(2, "0")} · {fmtDate(s.date, lang)}</span>
              <span className="p11-label" style={{ color: s.state === "VERIFIED" ? P11.yellow : P11.gray }}>{s.state}{s.verified_at ? ` · ${new Date(s.verified_at).toLocaleDateString("nl-NL")}` : ""}</span>
            </div>
          ))}
        </div>
      </div>
    </P11Layout>
  );
}
